import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../../../Configuration/configuration.service';
import { LocalStorageService } from '../../../Shared/common/local-storage.service';
import { CharityDataShareServiceService } from '../charities/services/charity-data-share-service.service';

@Injectable({
  providedIn: 'root'
})
export class FinalAccountsapiService {

  constructor(private http: HttpClient, private configService: ConfigurationService, private dataShareService: CharityDataShareServiceService, private lsService: LocalStorageService) { }
  private apiUrl = this.configService.getAPIBaseUrl();
  GetFinalNotes(id: any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/FinalAccounts/GetFinalNotes?id=`;
    return this.http.get(url + id);
  }
  GetTrustees(id: any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/FinalAccounts/GetTrustees?id=`;
    return this.http.get(url + id);
  }
  save(detials: any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/FinalAccounts/Save`;
    return this.http.post(url, detials);
  }

  GetFinalStatus(id: any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/FinalAccounts/GetFinalStatus?id=`;
    return this.http.get(url+id)
  }
}
